import { createContext } from 'react';
import { ILicense } from '../models/ILicense';

export const LicenseContext = createContext<ILicense | null>(null);
